<template>
    <div class="faceRecognition">
        <el-dialog
            title=""
            :close-on-click-modal="false"
            :show-close="false"
            :visible.sync="centerDialogVisible"
            width="800px"
            center>
            <el-row>
                <img :src="rzImg" style="width: 100px;float: left;margin-right:20px;"/>
                <p style="font-size:20px;">同学你好：</p>
                <p style="text-indent:2em;font-size:15px;">你需要完成人脸认证后才能继续操作！</p>
            </el-row>
            <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="notCertified">暂不认证</el-button>
            <el-button type="primary" @click="getCompetence">开始认证</el-button>
        </span>
        </el-dialog>
        <el-row v-show="distinguish_show"
                style="position: fixed;width: 100%;height: 100%;left: 0;top: 0;background-color: rgba(0,0,0,0.4);z-index: 2">
            <el-row style="width: 600px;margin: 0 auto;background-color: #ffffff;border-radius: 10px;margin-top: 10%;">
                <el-row style="text-align: center;margin-top: 10px;">
                    <el-row style="text-align: center;padding: 10px;color: #409eff;">{{ tips }}<strong
                        class="countdownNum">{{ countdownNum }}</strong></el-row>
                    <!-- <el-progress :percentage="percentage" status="success" :color="customColors"></el-progress> -->
                    <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
                    <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
                </el-row>
                <el-row style="text-align: center;">
                    <el-button type="primary" @click="stopNavigator('user')" style="margin-bottom: 10px;">取消识别
                    </el-button>
                </el-row>
            </el-row>
        </el-row>
    </div>
    <!--    </div>-->
</template>

<script>
import rzImg from '@/images/user/rz.png';
import * as faceapi from "face-api.js";
import {base64ToFile, getStudentInfoKeyForRoleTag} from "../common/ulit";
import {upload, upload_64} from "../common/request";
import CONFIG from "../common/config.js";

const faceCheckInterval = CONFIG.faceCheck.interval || 5;
export default {
    name: "faceRecognition",
    props: {
        visible: {//当前是否可见
            type: Boolean,
            default: true,
        },
        intervalTime: {//抓拍间隔时间，单位：秒 √
            type: Number,
            default: 10,
        },
        skip: {//跳过次数配置 √
            type: Number,
            default: 3,
        },
        score: {//人脸识别对比度配置 √
            type: Number,
            default: 70,
        },
        faceNumber: {//已验证次数 √
            type: Number,
            default: 3,
        }
        //2023年7月25日17点21分：后台配置字段已经不生效
        // photoCount: {//抓拍次数 √
        //     type: Number,
        //     default: 1,
        // },
    },
    data() {
        return {
            tag: 1,
            tips: "人脸识别中...",
            _countdownNum: faceCheckInterval,//倒计时，配置中
            countdownNum: 0,//倒计时
            rzImg: rzImg,
            centerDialogVisible: false,
            distinguish_show: false,
            videoWidth: 600,
            videoHeight: 400,
            imgSrc: '',
            thisCancas: null,
            thisContext: null,
            thisVideo: null,
            setTimeoutInfo: null
            // faceNumber: this.faceNumber
        };
    },
    computed: {
        getStudentInfoByLocal() {
            return JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())) || {};
        },
        getStudentId() {
            return this.getStudentInfoByLocal.studentId;
        },
        getFaceConfig() {
            //模式与字段的映射关系，决定权限字段的获取方式
            // const ruleMap = {
            //     course: ['coursePhotoIntervalTime', 'courseSkipTimes', 'courseFaceScore', 'coursePhotoCount'],
            //     job: ['jobPhotoIntervalTime', 'jobSkipTimes', 'jobFaceScore', 'jobPhotoCount'],
            //     exam: ['examPhotoIntervalTime', 'examSkipTimes', 'examFaceScore', 'examPhotoCount'],
            //     makeup: ['makeupExamPhotoIntervalTime', 'makeupExamSkipTimes', 'makeupExamFaceScore', 'makeupExamPhotoCount']
            // }
            return {
                intervalTime: this.intervalTime,
                skip: this.skip,
                score: this.score,
                // photoCount: this.photoCount
            }
        },
    },
    watch: {
        visible(bool) {
            console.log("watch 当前是否可见", bool);
            this.centerDialogVisible = !!bool;
            if (bool === false) {
                this.distinguish_show = false;
                clearTimeout(this.setTimeoutInfo);
                this.setTimeoutInfo = null;
            }
        },
        getFaceConfig(obj = {}) {
            console.log("获取当前课程播放的权限", obj)
            // this.centerDialogVisible = true;
            //TODO 完成人脸识别权限时打开这块注释！
            // if (!studentPhotoUrl) {
            //     this.centerDialogVisible = false;
            //     this.$message({
            //         message: "未上传学籍照片，请先上传学籍照片等待审核！",
            //         type: 'warning',
            //         onClose: () => {
            //             if (this.pageName == "examinationPage" || this.pageName == "examInfoPage") {
            //                 this.$closeWin();
            //             } else {
            //                 this.$router.go(-1);
            //             }
            //         }
            //     });
            //     return;
            // }
        }
    },
    created() {
        console.log("created 当前是否可见", this.visible);
        this.centerDialogVisible = this.visible;
        console.log("配置中的倒计时初始值", this._countdownNum, faceCheckInterval);
        this.countdownNum = faceCheckInterval;
        setInterval(() => {
            if (this.countdownNum > 1) {
                this.countdownNum -= 1;
            } else {
                this.countdownNum = undefined;
            }
        }, 1000)
        this.$forceUpdate();

    },
    mounted() {
        //这块有个缓存逻辑语法：this.$isEmpty(this.$ls.get(this.pageName))
    },
    methods: {
        notCertified() { //暂不认证
            this.centerDialogVisible = false;
            this.$router.go(-1);
            this.$emit('notCertified');
        },
        getCompetence() { //开始人脸识别
            this.countdownNum = faceCheckInterval;
            // this.faceNumber = 0;
            this.distinguish_show = true;
            this.centerDialogVisible = false;
            var _this = this;
            this.thisCancas = document.getElementById('canvasCamera')
            this.thisContext = this.thisCancas.getContext('2d')
            this.thisVideo = document.getElementById('videoCamera')
            // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {}
            }
            // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
            // 使用getUserMedia，因为它会覆盖现有的属性。
            // 这里，如果缺少getUserMedia属性，就添加它。
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // 首先获取现存的getUserMedia(如果存在)
                    var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
                    // 有些浏览器不支持，会返回错误信息
                    // 保持接口一致
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                    }
                    // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject)
                    });
                }
            }
            var constraints = {
                audio: false,
                video: {width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)'}
            }
            navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
                // 旧的浏览器可能没有srcObject
                if ('srcObject' in _this.thisVideo) {
                    _this.thisVideo.srcObject = stream
                } else {
                    // 避免在新的浏览器中使用它，因为它正在被弃用。
                    _this.thisVideo.src = window.URL.createObjectURL(stream)
                }
                _this.thisVideo.onloadedmetadata = function (e) {
                    _this.thisVideo.play();
                    setTimeout(() => {
                        _this.setImage();
                    }, 1000 * CONFIG.faceCheck.interval);
                }
            }).catch(err => {
                // console.log(err)
                this.$message({
                    type: "warning",
                    message: "摄像头无法打开，请检查设备或浏览器权限！",
                    // onClose: () => this.$router.go(-1)
                });
                this.$router.go(-1);
            });
        },
        process_skip() {
            /*人脸识别跳过，流程
            * 当skip是数字，并且当前识别次数大于skip，那么关闭人脸识别弹框
            * @return false 识别失败时不跳过
            * */
            //
            const {skip} = this.getFaceConfig;
            const skipIsNum = typeof +skip === 'number';
            console.log(this.faceNumber ,"this.faceNumber ");
            console.log(skip ,"skip");
            const isOverSkip = skipIsNum && (this.faceNumber >= skip);
            console.log("校验跳过流程", skipIsNum, isOverSkip, this.faceNumber, skip);
            if (!skipIsNum || !isOverSkip) {
                return false;
            }
            if (isOverSkip) {
                //满足了跳过人脸识别的条件，开始执行跳过流程
                console.log("满足了跳过人脸识别的条件，开始执行跳过流程");
                this.$emit('onSkip');
                this.stopNavigator();
                setTimeout(() => {
                    this.$message({
                        type: "info",
                        message: "人脸识别已跳过！"
                    })
                    this.centerDialogVisible = false;
                }, 16)
                return true;
            }
        },
        //  绘制图片（拍照功能）
        setImage() {
            var _this = this
            ++_this.faceNumber;
            // this.countdownNum = faceCheckInterval;//恢复倒计时
            // console.log("恢复倒计时", this.countdownNum)
            if (_this.process_skip()) {
                return;
            }


            // 点击，canvas画图
            _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
            // 获取图片base64链接
            var base64 = this.thisCancas.toDataURL('image/jpeg');
            _this.imgSrc = base64;
            this.getFace(); //调用人脸识别接口对比
        },
        async upload(base64) {
            console.log("base64",base64);
            //将拍照图片上传到服务器，获取地址用于外部的photoUrl字段
            const imgName = 'photo:' + new Date().getTime();
            // console.log('imgName', imgName)
            // const formData = new FormData();
            // formData.append('file',base64ToFile())
            const res = await upload_64(base64)
            // console.log("上传之后", res)
            return res.data;//图片地址路径
        },
        // base64转文件
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, {type: mime})
        },
        // 关闭摄像头 取消人脸识别
        stopNavigator(type) {
            //参数意义：type=='user'，标识用户手动点击了取消识别，那么传递给父组件自行决定后续行为
            this.$emit('stopNavigator', type)
            this.clearTime();
            this.distinguish_show = false;
            this.centerDialogVisible = false;
            this.thisVideo.srcObject.getTracks()[0].stop();
        },
        async getFace() { // 调后端接口，后端调百度人脸识别接口
            const params = {
                image: this.imgSrc,
                studentId: this.getStudentId,
                faceScore: this.getFaceConfig.score
            }
            const imgPath = await this.upload(this.imgSrc);

            this.$store.dispatch("user/face", params).then((ret) => {
                if (ret.code !== 0 && ret.code !== '0') {
                    this.$emit('faceOver', -1, imgPath);
                    this.$message({message: ret.msg, type: 'warning'});
                    // this.setImage();
                }

                if (ret.code === 0 || ret.code === '0') {
                    this.$emit('faceOver', 1, imgPath);
                    // this.$ls.set(this.pageName, 1, 60 * 60 * 1000); //设置当前页面的人脸识别一个小时后失效
                    this.thisVideo.srcObject.getTracks()[0].stop();
                    this.distinguish_show = false;
                    this.centerDialogVisible = false;
                    this.$parent.laodShow = true;

                    this.$message({
                        message: "人脸识别成功！",
                        type: 'success',
                    });
                }
            })
        },
        clearTime() {
            if (!this.$isEmpty(this.setTimeoutInfo)) {
                clearTimeout(this.setTimeoutInfo);
            }
        }
    },
    beforeDestroy() {
        this.clearTime();
        this.stopNavigator();
    },
};
</script>

<style scoped>
.faceRecognition {
    .see {
        position: relative;
    }

    .see canvas {
        position: absolute;
        top: 0;
        left: 0;
    }

    .option {
        padding-bottom: 20px;
    }

    .option div {
        padding: 10px;
        border-bottom: 2px #42b983 solid;
    }

    .option div label {
        margin-right: 20px;
    }

    .countdownNum {
        color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/faceRecognition_K.vue